import { selectors } from 'publisher/reducers/managementReducer'
import { shallowEqual, useSelector } from 'react-redux'

export { selectors }

export default function useManagement(selector) {
  return useSelector(state => selector(state.management), shallowEqual)
}
